<template>
  <v-container>
    <v-toolbar color="primary" dark>
      <v-toolbar-title>Wholesale Management</v-toolbar-title>
      <v-spacer />
      <v-text-field v-if="authPermissions.has('whole_sales:view')" v-model="search" append-icon="mdi-magnify" dense
        hide-details placeholder="Search..." @input="reload" style="max-width: 300px" />
    </v-toolbar>

    <v-row class="mt-4">
      <v-col cols="6" v-if="authPermissions.has('whole_sales:create')">
        <create-whole-sale @created="reload" />
      </v-col>


      <v-col cols="6" v-if="authPermissions.has('whole_sales:view')">
        <index-whole-sale @sync-stocks="onSyncStocks" :search="search" @edit="openEdit" ref="indexWholeSaleRef" />
      </v-col>
    </v-row>
    <v-dialog v-model="editDialog" eager width="800">
      <edit-whole-sale @close="editDialog = false" ref="editWholeSale" @updated="reload" />
    </v-dialog>
    <sync-stocks ref="syncStocksRef" />
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { useWatchEffect } from '../../../../lib/utils'

const [watchEffect] = useWatchEffect()

export default {
  name: 'WholesalePage',
  components: {
    CreateWholeSale: () => import('./Create.vue'),
    EditWholeSale: () => import('./Edit.vue'),
    IndexWholeSale: () => import('./Index.vue'),
    SyncStocks: () => import('./SyncStocks.vue'),
  },
  data() {
    return {
      search: '',
      refreshKey: 0,
      editDialog: false,
    }
  },
  computed: {
    ...mapState({
      authPermissions: state => state.auth.userPermissions,
    }),
  },
  methods: {
    reload() {
      watchEffect((onCleanup) => {
        const controller = new AbortController()
        onCleanup(() => {
          controller.abort()
        })
        this.$refs?.indexWholeSaleRef?.fetch?.(controller)
      }, 'indexWholeSaleRefFetch')
    },
    openEdit(data) {
      if (this.authPermissions.has('whole_sales:edit')) {
        this.$refs.editWholeSale.populate(data)
        this.editDialog = true
      }
    },
    onSyncStocks(wholeSaleId) {
      console.log('Syncing stocks for whole sale ID:', wholeSaleId)
      this.$refs.syncStocksRef?.openDialog?.(wholeSaleId)
    },
  },
}
</script>